export default __webpack_public_path__ + "static/media/game_01_wrong.1c26fff9.png";